import httpCommon from "./http-common";

// Get pipeline
const getPipeline = (businessId: number) => {
  return httpCommon.get(`/v1/get/dealPipeline/${businessId}`);
};

// Create pipeline
const createPipeline = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/dealPipeline/${businessId}`, data);
};

// Update pipeline
const updatePipeline = (pipelineId: number, data: any) => {
  return httpCommon.put(`/v1/update/dealPipeline/${pipelineId}`, data);
};

// Get all deals
const getAllDeals = (businessId: number) => {
  return httpCommon.get(`/v1/get/deals/${businessId}`);
};

// Get deal by ID
const getDeal = (dealId: string) => {
  return httpCommon.get(`/v1/get/deal/${dealId}`);
};

// Create deal
const createDeal = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/deal/${businessId}`, data);
};

// Update deal
const updateDeal = (dealId: number, data: any) => {
  return httpCommon.put(`/v1/update/deal/${dealId}`, data);
};

// Update deal stage
const updateDealStage = (dealId: number, stageId: number) => {
  return httpCommon.put(`/v1/update/dealStage/${dealId}`, { dealStageId: stageId });
};

// Delete deal
const deleteDeal = (dealId: number) => {
  return httpCommon.delete(`/v1/delete/deal/${dealId}`);
};

const DealService = {
  getPipeline,
  createPipeline,
  updatePipeline,
  getAllDeals,
  getDeal,
  createDeal,
  updateDeal,
  updateDealStage,
  deleteDeal
};

export default DealService; 